import { JsonObject } from 'json2typescript';

import { OrderSignedInterface } from '../../../core';

@JsonObject('OrderSigned')
export class OrderSigned implements OrderSignedInterface {
    private readonly _xml: string = undefined;

    constructor(xml?: string) {
        this._xml = xml;
    }

    get xml(): string {
        return this._xml;
    }
}
